import * as React from 'react';
import { Card, Kv, Button } from '@comps';
import { Form, Space } from 'antd';
import { Http, Lang } from '@utils';

export interface Props extends React.Props<HTMLElement>,
  React.BaseHTMLAttributes<HTMLElement> {
  ids: string[],
  onConfirm: () => void,
  onClose: () => void,
};

const LinesMd: React.FC<Props> = ({ ids, onClose, onConfirm }: Props) => {
  const [form] = Form.useForm();

  const handleConfirm = React.useCallback(() => Lang.noError(async () => {
    await form.validateFields();
    const formData = form.getFieldsValue();
    await Http.post('/tax/transfers', {
      ids,
      financialOfficerId: formData.financialOfficerId,
    });
    onConfirm();
  }), [form, ids, onConfirm]);

  return (<Card title='请选择大区财务' style={{ marginBottom: '0' }}>
    <Form form={form} labelCol={{ span: 6 }}
      style={{ padding: '30px 60px' }}>
      <Form.Item label="大区财务"
        name="financialOfficerId"
        rules={[{ required: true, message: '请选择大趋财务' }]}>
        <Kv url="/tax/transfers/financialOfficersKv"></Kv>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6 }}>
        <Space>
          <Button type="primary"
            clickCallback={handleConfirm}>确认提交</Button>
          <Button onClick={() => onClose()}>取消</Button>
        </Space>
      </Form.Item>
    </Form>
  </Card>);
};

export default LinesMd;
